export enum EnumAgreementType {
  /** 用户协议 */
  USER = 'user',
  /** 隐私协议 */
  PROVACY = 'privacy',
  /** 联系我们 */
  Contact = 'contact',
  /** 侵权反馈 */
  Feedback = 'feedback'
}
